import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SrAdminTourCardCollapsibleRow extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      isCollapsed: true,
    };
  }

  _toggleCollapse = () => {
    const { isCollapsed } = this.state;
    this.setState({ isCollapsed: !isCollapsed });
  };

  render() {
    const { title, children } = this.props;
    const { isCollapsed } = this.state;

    return (
      <div className="SrAdminTourCardCollapsibleRow">
        <div className="headerContainer" onClick={this._toggleCollapse}>
          <span className="title">{title}</span>
          <div className="iconContainer">
            <div className={classnames('icon', { notCollapsed: !isCollapsed })} />
          </div>
        </div>

        {!isCollapsed && <div className="bodyContainer">{children}</div>}
      </div>
    );
  }
}

SrAdminTourCardCollapsibleRow.displayName = 'SrAdminTourCardCollapsibleRow';

export default SrAdminTourCardCollapsibleRow;
